export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20terracotta%20and%20cream%20abstract%20artistic%20background%20with%20gentle%20curved%20shapes%20and%20subtle%20texture%20layers%2C%20minimalist%20elegant%20composition%2C%20soft%20diffused%20lighting%20with%20golden%20undertones%2C%20editorial%20aesthetic%2C%20clean%20contemporary%20design%2C%20no%20text%20no%20people&width=1800&height=1200&seq=hero-main-litbuy-v2&orientation=landscape"
          alt="Litbuy Spreadsheet resource center background"
          className="w-full h-full object-cover object-top"
          title="Litbuy Spreadsheet resource center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl pt-32 pb-20">
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight lowercase">
            the ultimate litbuy spreadsheet resource center
          </h1>

          <p className="mt-6 text-base md:text-lg text-background-50/80 max-w-xl leading-relaxed">
            Discover comprehensive guides, templates, safety resources, and comparison tools — everything you need to master Litbuy Spreadsheet and boost your productivity.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-3 rounded-full bg-background-50 px-7 py-3.5 text-sm font-semibold text-foreground-950 transition-all duration-300 cursor-pointer hover:bg-background-100 hover:scale-[1.02]"
            >
              buy it now
              <span className="w-5 h-5 flex items-center justify-center rounded-full bg-foreground-950">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-3 rounded-full border-2 border-background-50/50 px-7 py-3.5 text-sm font-medium text-background-50 transition-all duration-300 cursor-pointer hover:bg-background-50/10"
            >
              explore more
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/40 flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}